import { t, TFunction } from 'i18next';

import { i18nNameSpace } from '@shared/consts/i18n.ts';

export function translateApiErrorFieldPath(fieldPath: string, translate: TFunction = t): string {
  const translationKey = `api.error.fieldPath.${fieldPath}`;
  const translatedFieldPath = translate(translationKey, {
    ns: i18nNameSpace.API,
    defaultValue: fieldPath,
  });

  if (typeof translatedFieldPath !== 'string' || translatedFieldPath === translationKey) {
    return fieldPath;
  }

  return translatedFieldPath;
}
